import {
  CheckInCardTestPeriodFragment,
  DashboardMostRecentLabSubmissionFragment,
  HealthFactorAdjustment,
  Maybe,
  MostRecentLabSubmissionWithResultsFragment,
} from '#apollo/schema';

const getSelectedActionPlanAdjustments = (actionPlan: any): HealthFactorAdjustment[] => {
  return actionPlan?.adjustments?.filter((item: HealthFactorAdjustment) => item.selected) || [];
};

const eligibleForCheckIn = (
  currentTestPeriod: CheckInCardTestPeriodFragment,
  hasSelectedActionPlan: boolean,
) => {
  const currentDate = new Date();
  const isStarted =
    currentTestPeriod?.startedAt && new Date(currentTestPeriod?.startedAt) <= currentDate;
  if (!isStarted) {
    return null;
  }
  if (!hasSelectedActionPlan) {
    return null;
  }

  return currentTestPeriod?.checkInStats.find(({completed, startedOn, endedOn}) => {
    return currentDate >= new Date(startedOn) && currentDate <= new Date(endedOn) && !completed;
  });
};

export const processDashboardData = ({
  mostRecentLabSubmission,
  labSubmissions,
  currentTestPeriod,
  mostRecentLabSubmissionWithResults,
}: {
  mostRecentLabSubmission: Maybe<DashboardMostRecentLabSubmissionFragment> | undefined;
  labSubmissions: Maybe<{id: string}[]> | undefined;
  currentTestPeriod: Maybe<CheckInCardTestPeriodFragment> | undefined;
  mostRecentLabSubmissionWithResults: Maybe<MostRecentLabSubmissionWithResultsFragment> | undefined;
}) => {
  const hasLabSubmissions = !!labSubmissions?.length;
  const selectedActionPlan =
    mostRecentLabSubmissionWithResults?.userSurveySubmission?.surveyAssessment?.selectedActionPlan;
  const {labAssessment, registeredDate} = mostRecentLabSubmissionWithResults || {};
  const mostRecentStatus = mostRecentLabSubmission?.status;
  const hasPriorResults = !!(
    mostRecentLabSubmissionWithResults &&
    mostRecentLabSubmissionWithResults?.id !== mostRecentLabSubmission?.id
  );

  const selectedAdjustments = getSelectedActionPlanAdjustments(selectedActionPlan);
  const hasSelectedActionPlan = Array.isArray(selectedAdjustments);
  let canCheckIn = false;
  if (currentTestPeriod && hasSelectedActionPlan) {
    canCheckIn = !!eligibleForCheckIn(currentTestPeriod, hasSelectedActionPlan);
  }

  return {
    hasLabSubmissions,
    selectedAdjustments,
    hasSelectedActionPlan,
    labAssessment,
    registeredDate,
    mostRecentStatus,
    canCheckIn,
    hasPriorResults,
  };
};
